import React from 'react';

export default ({ error }) => {
  const style = {
    color: 'red',
    textAlign: 'center'
  };

  return (
    <div id="errorText" style={style}>
      {error}
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/SecurityBoxCommonError.jsx